import React, { useState, useEffect, createContext, useContext } from "react";
import { getEventTypes} from "../services/otsEventService";
import { EventType} from "../Models/EventType";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { useToast } from "./ToastProvider";
import { NOTIFICATION_TYPES } from '../components/ToastNotification/toastConstants';

 export type EventTypeContextType = {
    eventTypes: EventType[];
    selectedEventType: string;
    isEventTypeHttpError?: boolean;
  };

const EventTypeContext = createContext<EventTypeContextType | null>(null);

export const  EventTypeProvider = ({ children, eventTypeName }) => {
  const [eventTypes, setEventTypes] = useState<EventType[]>([]);
  const [selectedEventType, setSelectedEventType] = useState<string>(eventTypeName);
  const [isEventTypeHttpError, setIsEventTypeHttpError] = useState(false);
  const { userData, getLatestAccessToken} = useAuthentication();
  const { addToast } = useToast();

    useEffect(() => {
      setSelectedEventType(eventTypeName);
        getLatestAccessToken().then((token) => {
          userData.access_token = token;
          getEventTypes(userData.access_token, userData.profile.company, userData.profile.email)
            .then((data) => {
              setEventTypes(data);
              setIsEventTypeHttpError(false);
          },
          (error) => {
            console.log(error);
            setEventTypes([]);
            addToast(NOTIFICATION_TYPES.WARNING,'Unable to load event types.', 'Please try again.');
            setIsEventTypeHttpError(true);
          });
        });
      return () => {
        setEventTypes([]);
      };
    }, [userData, eventTypeName]);

    return (
        <EventTypeContext.Provider value={{ eventTypes, selectedEventType, isEventTypeHttpError }}>
            {children}
        </EventTypeContext.Provider>
    );
}

// Custom hook that exposes the EventTypeContext
// Allows lower components to access EventTypeProvider's event types
export const useEventType = () => {
    const context = useContext(EventTypeContext);
    if (!context) {
      throw new Error(
        "useEventType must be used within a EventTypeProvider. Wrap a parent component in <EventTypeProvider> to fix this error."
      );
    }
    return context;
  };